import React from 'react';
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Axios from 'axios';
import Page from '../../Common/Page';
import ProgressIndicator from '../../Common/ProgressIndicator';
import ErrorIndicator from '../../Common/ErrorIndicator';

function PageDetailsPage(props) {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(false);
    const [page, setPage] = useState(null);
    const { id } = useParams();

    useEffect(() => {
        setIsLoading(true);
        Axios.get(`/pages/${id}`).then(res => {
            setPage(res);
            setIsLoading(false);
        }, err => {
            setIsLoading(false);
            setError(true);
        });
    }, [id]);

    if (isLoading)
        return <ProgressIndicator />;

    if (error)
        return <ErrorIndicator text="A rendezvény letöltése sikertelen." />;

    if(page)
        return (
            <Page>
                <div dangerouslySetInnerHTML={{ __html: page.content }} />
            </Page>
        );

    return null;
}

export default PageDetailsPage;